import React, { useContext, useState } from 'react'
import './ConfirmDialogModal.css'

import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Container,
  Row,
  Col,
  Button,
} from 'reactstrap'
import { SPContext } from '../../SPContext'

const ConfirmDialogModal = React.memo(
  ({
    size,
    isOpen,
    title,
    content,
    fnAction,
    btn_ok_label,
    btn_cancel_label,
    className,
    isProcessing,
  }) => {
    const [is_processing, setIsProcessing] = useState(isProcessing)

    const lcFnAction = (e, confirmed) => {
      setIsProcessing(true)
      fnAction(e, confirmed)
    }

    const beforeClose = () => {
      setIsProcessing(false)
    }

    return (
      <Modal
        size={size || 'lg'}
        isOpen={isOpen}
        centered={true}
        toggle={e => lcFnAction(e, false)}
        onClosed={beforeClose}
        // className={
        //   (className === undefined ? '' : className) +
        //   ' modal-dialog-scrollable modal-dialog-centered sp-event-modal'
        // }
      >
        <ModalHeader toggle={e => lcFnAction(e, false)}>{title}</ModalHeader>

        <ModalBody>
          <Container>
            <Row>
              <Col>{content}</Col>
            </Row>
          </Container>
        </ModalBody>
        <ModalFooter>
          <Container>
            <Row>
              <Col xs='6'>
                <Button
                  color='danger'
                  onClick={e => lcFnAction(e, true)}
                  className={
                    btn_ok_label === 'none' ? 'sp-dialog-modal-button-hide' : ''
                  }
                  disabled={is_processing || false}
                >
                  {btn_ok_label || 'Confirm'}{' '}
                  {is_processing ? (
                    <i className='fas fa-sync-alt fa-spin' />
                  ) : null}
                </Button>
              </Col>
              <Col xs='6 text-right'>
                <Button
                  color='secondary'
                  onClick={e => lcFnAction(e, false)}
                  className={
                    btn_cancel_label === 'none'
                      ? 'sp-dialog-modal-button-hide'
                      : ''
                  }
                  disabled={is_processing || false}
                >
                  {btn_cancel_label || 'Cancel'}
                </Button>
              </Col>
            </Row>
          </Container>
        </ModalFooter>
      </Modal>
    )
  },
)

const ConfirmDialogModalContainer = React.memo(props => {
  const { handleOpenEventModal } = useContext(SPContext)
  return (
    <ConfirmDialogModal
      handleOpenEventModal={handleOpenEventModal}
      {...props}
    />
  )
})

export default ConfirmDialogModalContainer
